document.addEventListener("DOMContentLoaded", function () {
  const breadcrumbWrapper = document.querySelector("h6#breadcrumbs > span");
  const breadcrumbSpans =
    breadcrumbWrapper.querySelectorAll("span[data-index]");
  const total = breadcrumbSpans.length;

  const isMobile = window.innerWidth <= 576;
  const isTablet = window.innerWidth > 576 && window.innerWidth <= 992;

  // Show all on desktop
  if (!isMobile && !isTablet) return;

  // Show first, last two
  const showIndices = [0, total - 2, total - 1];

  breadcrumbSpans.forEach((span, index) => {
    if (!showIndices.includes(index)) {
      span.style.display = "none"; // Hide breadcrumb with separator
    }
  });

  // Insert ellipsis styled like original breadcrumb
  if (total > (isMobile ? 3 : 4)) {
    const ellipsisSpan = document.createElement("span");
    ellipsisSpan.className = "ellipsis";
    ellipsisSpan.innerHTML = "&nbsp;…&nbsp;"; // Add spacing to match original
    const insertBefore = breadcrumbSpans[total - 2];
    breadcrumbWrapper.insertBefore(ellipsisSpan, insertBefore);
  }
});
